import HashIds from "hashids";

export const hashids = new HashIds("", 10);
